import styled from 'styled-components';
import * as Parent from '../Base/style';
export const PopperContainer = styled(Parent.PopperContainer)``;
export const ModalHeader = styled(Parent.ModalHeader)``;
export const ModalContent = styled(Parent.ModalContent)``;
export const DocClose = styled(Parent.DocClose)``;
